/**
 * Public documentation page on cataam.com for the connectors that run automated checks (every check and the
 * controls it proves). Keys are the platform vendor keys; values are the cataam.com /integrations/<slug>/ slugs.
 */
const SLUGS = {
  aws: 'aws', azure: 'microsoft-azure', kubernetes: 'kubernetes', digitalocean: 'digitalocean',
  cloudflare: 'cloudflare', vercel: 'vercel', supabase: 'supabase', snowflake: 'snowflake',
  github: 'github', gitlab: 'gitlab', bitbucket: 'bitbucket', okta: 'okta',
  googleworkspace: 'google-workspace', jumpcloud: 'jumpcloud', onelogin: 'onelogin', duo: 'cisco-duo',
  pingone: 'ping-identity', auth0: 'auth0', clerk: 'clerk', crowdstrike: 'crowdstrike', jamf: 'jamf-pro',
  kandji: 'kandji', intune: 'microsoft-intune', datadog: 'datadog', splunk: 'splunk',
  pagerduty: 'pagerduty', sentry: 'sentry', servicenow: 'servicenow', postmark: 'postmark',
};

/** URL of the vendor's public integration page, or null when it has none. */
export function integrationDocsUrl(vendorKey) {
  const slug = SLUGS[String(vendorKey || '').toLowerCase()];
  return slug ? `https://cataam.com/integrations/${slug}/` : null;
}
